import { StrictMode } from 'react'
import { UIProvider } from '@consumer/ui'
import { createRoot } from 'react-dom/client'
import { HashRouter } from 'react-router-dom'

// Must run before the React tree renders: initializes i18next synchronously.
import './i18n'
// Must run before any map mounts: points maplibre-gl at its bundled worker.
import './maplibreWorker'
import App from './App'
import reportWebVitals from './reportWebVitals'
import { appTheme, themeExtras } from './utils/theme/configureTheme'

import './index.css'

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <UIProvider theme={appTheme} nativeBase={themeExtras}>
      <HashRouter>
        <App />
      </HashRouter>
    </UIProvider>
  </StrictMode>
)

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals()
